import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import store from '@/store';
import 'nprogress/nprogress.css';
import i18n from '@/plugins/i18n';
import VueAppInsights from 'vue-application-insights';

Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths,
});

// router gards
router.beforeEach(async (to, from, next) => {
    var apiURL = store.getters['account/apiUrl'];
    if (!apiURL) {
        var config = await fetch('/config.json').then((response) => response.json());
        store.dispatch('account/setApiUrl', config.apiUrl);
    }
    var messages = store.getters['account/localization'];

    if (messages == null) {
        await store.dispatch('account/getLocalization');
        messages = store.getters['account/localization'];
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['account/isLoggedIn']) {
            if (to.matched.some(record => record.meta.requiredRole != -1 && record.meta.requiredRole != store.getters['account/currentRole'])) {
                NProgress.start();
                next('/403');
                return;
            }
            const cultureCode = store.getters['account/user'].CultureCode;
            i18n.setLocaleMessage(cultureCode, messages);
            i18n.locale = cultureCode;
            NProgress.start();
            next();
            return;
        } else {
          const cultureCode = 'en';
            i18n.setLocaleMessage(cultureCode, messages);
            i18n.locale = cultureCode;
            localStorage.setItem('redirectUrl', to.path);
        }
        NProgress.start();
        next('/login');
    } else {
        const cultureCode = 'en';
        i18n.setLocaleMessage(cultureCode, messages);
        i18n.locale = cultureCode;
        NProgress.start();
        next();
    }
});

router.afterEach(() => {
    NProgress.done();
});

if (process.env.NODE_ENV !== 'development' && window.appInsights) {
    Vue.use(VueAppInsights, {
        //id: 'XXXXXXXX--XXXX-XXXX-XXXXXXXXXXXX',
        appInsights: window.appInsights,
        router
    });
}

export default router;
